import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import heroImage from "@/assets/hero-research.webp";
import NemesisPainDialog from "@/components/NemesisPainDialog";

const Hero = () => {
  // Preload hero image for LCP optimization
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = heroImage;
    link.fetchPriority = 'high';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const scrollToDonation = () => {
    const donationSection = document.getElementById('donation-section');
    if (donationSection) {
      donationSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const el = document.getElementById('about');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative overflow-hidden bg-gradient-hero min-h-screen flex items-center">
      <div className="absolute inset-0 bg-black/20"></div>
      <img 
        src={heroImage}
        alt=""
        width={1920}
        height={1280}
        fetchPriority="high"
        decoding="sync"
        className="absolute inset-0 w-full h-full object-cover mix-blend-soft-light"
      />
      
      {/* Top contact button */}
      <div className="absolute top-6 right-6 z-10">
        <Link to="/fr/contact">
          <Button size="sm" className="bg-white text-primary hover:bg-white/90">Contact</Button>
        </Link>
      </div>
      
      <div className="relative container mx-auto px-4 py-24 text-center">
        <div className="max-w-4xl mx-auto text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Nous recherchons aujourd'hui pour
            <span className="block bg-gradient-to-r from-white to-secondary-light bg-clip-text text-transparent">
              guérir demain
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto leading-relaxed">
            Nous consacrons nos efforts à la recherche sur les maladies neurologiques, 
            en recherchant des traitements innovants qui améliorent la qualité de vie de millions de personnes.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg" 
              className="bg-secondary hover:bg-secondary-light text-white px-8 py-4 text-lg font-semibold shadow-strong transition-all duration-300 hover:scale-105"
              onClick={scrollToDonation}
            >
              Faire un Don
            </Button>
            <Link to="/fr/research-projects">
              <Button 
                variant="outline" 
                size="lg"
                className="border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-4 text-lg font-semibold backdrop-blur-sm bg-white/10 transition-all duration-300"
              >
                Découvrez Notre Recherche
              </Button>
            </Link>
          </div>
          
          <NemesisPainDialog language="fr" triggerText="NEMESISPAIN Essai Clinique - ACTUALITÉS" />
        </div>
      </div>
      
      <button 
        type="button"
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce"
        aria-label="Faire défiler vers la section À propos"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </button>
    </section>
  );
};

export default Hero;
